import React from 'react';
import { Link } from 'react-router-dom';

const LegalFooter = ({ className = "" }) => {
  return (
    <div className={`flex flex-col items-center justify-center space-y-2 z-40 pointer-events-auto ${className}`}>
      <div className="text-[9px] md:text-[10px] text-gray-500 tracking-widest font-light flex items-center space-x-4">
        <Link to="/terms" className="hover:text-amber-400 transition-colors duration-300">服務條款 (Terms)</Link>
        <span className="w-1 h-1 bg-gray-600 rounded-full" />
        <Link to="/privacy" className="hover:text-amber-400 transition-colors duration-300">隱私權政策 (Privacy)</Link>
      </div>
      <p className="text-[8px] md:text-[9px] text-gray-600 tracking-wider text-center px-4">
        使用本服務需年滿 18 歲。對話由 AI 生成，不構成任何醫療或心理諮商專業建議。
      </p>
    </div>
  );
};

export default LegalFooter;